import React, { useEffect, useState, useRef } from "react";
import "../../App.css";
import PageTitle from "../../Module/pageTitle";
import DatePicker from "../../Component/datePicker";
import { useDispatch } from "react-redux";
import {
  CxoPubOrderHistory,
  getExamListNew,
  getParentCourseNew,
  getSellingSource,
  getSubCategory,
} from "../../Action/courseAction";
import moment from "moment";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import LabelField from "../../Component/labelField";
import Dropdown from "../../Component/dropdown";
import { getSubExam } from "../../Action/adminPanelAction";
import AdminTable from "../../Component/adminTable";
import { stockSellingType } from "../../Utils/dataConstants";

//ADD FILTER - SELLING SOURCE FROM,
//LIST - SNO EXAM NAME EXAM STREAM BOOK NAME BOOK TYPE DATE AMOUNT TYPE
const SellingSrcRevenueAnalysis = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    startDate: moment.utc(new Date()).format("YYYY-MM-DD"),
    endDate: moment.utc(new Date()).format("YYYY-MM-DD"),
    stockSellingValue: "",
    sellingSourceValue: "",
    sellingSourceList: [],
    subCategory: "",
    cxoPubBookHistory: [],
  });
  const updateState = (key) => {
    setState((prev) => ({ ...prev, ...key }));
  };

  useEffect(() => {
    dispatch(
      getSellingSource((resp) => {
        if (resp?.length > 0) updateState({ sellingSourceList: resp });
        else updateState({ sellingSourceList: [] });
      })
    );
  }, []);

  const getCxoBookHistory = () => {
    const {
      startDate,
      endDate,
      sellingSourceValue,
      stockSellingValue,
      examName,
      parentCourseVal,
      subExamName,
    } = state;
    const postData = {
      startDate: startDate,
      endDate: endDate,
    };
    if (stockSellingValue) postData.location = stockSellingValue?.value;
    if (sellingSourceValue) postData.sellingSourceId = sellingSourceValue?._id;
    dispatch(
      CxoPubOrderHistory(
        postData,
        (res) => {
          if (res?.length > 0) updateState({ cxoPubBookHistory: res });
          else updateState({ cxoPubBookHistory: [] });
        },
        () => {}
      )
    );
  };

  const changeEndDate = (value) => {
    const { startDate } = state;
    updateState({ endDate: value });
    if (value < startDate) {
      dispatch(showErrorSnackbar("End date must be greater than start date"));
    }
  };

  const onChangeList = (value, key) => {
    if (key === "stockSellingType") {
      updateState({ stockSellingValue: value });
    } else if (key === "sellingSourceValue") {
      updateState({ sellingSourceValue: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    getCxoBookHistory();
  };

  const renderList = () => {
    const { cxoPubBookHistory } = state;
    return (
      <AdminTable
        pagename={"SellingSrcRevenueAnalysis"}
        tableHead={[
          "S.N",
          "EXAM NAME",
          "EXAM STREAM",
          "DATE",
          "QUANTITY",
          "AMOUNT",
        ]}
        tableData={cxoPubBookHistory ? cxoPubBookHistory : []}
        edit={false}
      />
    );
  };

  const renderSearch = () => {
    const {
      startDate,
      endDate,
      stockSellingValue,
      sellingSourceValue,
      sellingSourceList,
    } = state;
    return (
      <div>
        <form className="row " onSubmit={handleSubmit}>
          <div className="d-flex mb-2 align-items-center col-4 pe-4">
            <div className="col-md-4">
              <LabelField labelName={"Start Date"} />
            </div>
            <DatePicker
              setInputText={(value) => updateState({ startDate: value })}
              value={startDate}
              Isrequired={true}
            />
          </div>
          <div className="d-flex mb-2 align-items-center col-4 pe-4">
            <div className="col-md-4">
              <LabelField labelName={"End Date"} />
            </div>
            <DatePicker
              setInputText={(value) => changeEndDate(value)}
              value={endDate}
              Isrequired={true}
            />
          </div>
          <div className="col-4 d-flex mb-2 align-items-center">
            <div className="col-md-4">
              <LabelField labelName={"Selling Type"} isRequired />
            </div>
            <Dropdown
              labelName="Select Selling Type"
              setInputText={(value) => onChangeList(value, "stockSellingType")}
              options={stockSellingType}
              value={stockSellingValue}
            />
          </div>
          <div className="col-4 d-flex mb-2 align-items-center">
            <div className="col-md-4">
              <LabelField labelName={"Selling Source"} isRequired />
            </div>
            <Dropdown
              labelName={"Selling Source"}
              value={sellingSourceValue}
              options={sellingSourceList}
              setInputText={(val) => onChangeList(val, "sellingSourceValue")}
            />
          </div>
          <div className="d-flex mb-2 align-items-center col-4 pe-4 ">
            <button
              type="submit"
              className={`btn mb-3 submitbtn ${
                validations() ? "btn-secondary" : "btn-primary"
              }`}
              disabled={validations()}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    );
  };

  const validations = () => {
    const { startDate, endDate } = state;
    return startDate === "" || endDate === "";
  };

  return (
    <div className="contentBox">
      <PageTitle name={"Selling Source Revenue"} />
      <div className="formDiv contentScrollbar">
        <div className="col-12 formWidth">
          {renderSearch()}
          {renderList()}
        </div>
      </div>
    </div>
  );
};

export default SellingSrcRevenueAnalysis;
